// Mappings between avatar's sizes and variants, and design tokens
import { css } from '@emotion/react';
import { theme } from '../theme';
import { tokens } from '../tokens';
import { resolveNumericContentFontSize } from './helpers';
const sizeMap = {
    huge: {
        contentSizing: '96px',
        fontSize: '116px',
        sizing: '160px',
    },
    large: {
        contentSizing: '36px',
        fontSize: '36px',
        sizing: '64px',
    },
    medium: {
        contentSizing: '22px',
        fontSize: tokens.fontSizes.xxlarge,
        sizing: '40px',
    },
    small: {
        contentSizing: '18px',
        fontSize: tokens.fontSizes.large,
        sizing: '32px',
    },
    xlarge: {
        contentSizing: '56px',
        fontSize: '64px',
        sizing: '96px',
    },
    xsmall: {
        contentSizing: '14px',
        fontSize: tokens.fontSizes.small,
        sizing: '24px',
    },
    xxlarge: {
        contentSizing: '76px',
        fontSize: '96px',
        sizing: '128px',
    },
    xxsmall: {
        contentSizing: '10px',
        fontSize: '8px',
        sizing: '16px',
    },
};
const avatarStaticStyle = css({
    flexShrink: 0,
    fontFamily: tokens.fontFamilies.sansSerif,
    overflow: 'hidden',
});
export function avatarStyle({ contentFill, size, variant, }) {
    const isTransparentGrey = variant === 'greyLight' || variant === 'transparentGrey';
    // Set the styles as the default base colors or the specified accent variant
    const variantStyle = variant === 'base'
        ? {
            main: theme.background.contrastInverse,
            textOnColor: theme.text.inverse,
        }
        : theme[isTransparentGrey ? 'transparentGrey' : variant];
    const backgroundColor = isTransparentGrey
        ? variantStyle.subtler
        : variantStyle.main;
    const background = contentFill
        ? `radial-gradient(farthest-side, ${backgroundColor} calc(100% - 1px), transparent)`
        : backgroundColor;
    return [
        avatarStaticStyle,
        css({
            // Fix for background-color and border-radius combo artifacts
            background,
            borderRadius: sizeMap[size].sizing,
            color: variantStyle.textOnColor,
            fontSize: sizeMap[size].fontSize,
            height: sizeMap[size].sizing,
            lineHeight: sizeMap[size].sizing,
            width: sizeMap[size].sizing,
        }),
    ];
}
const avatarContentStaticStyle = css({
    '& > *': {
        margin: 'auto 0',
    },
    '& > :not(svg)': {
        minWidth: '100%',
    },
    display: 'flex',
    fontVariantNumeric: 'tabular-nums',
    height: '100%',
    justifyContent: 'center',
    width: '100%',
});
export function avatarContentStyle({ content, contentFill, size, }) {
    return [
        avatarContentStaticStyle,
        css(Object.assign({ '& > *': {
                minHeight: contentFill ? '100%' : sizeMap[size].contentSizing,
            }, '& > svg': {
                width: contentFill ? '100%' : sizeMap[size].contentSizing,
            } }, (typeof content === 'number' && {
            fontSize: resolveNumericContentFontSize(content),
        }))),
    ];
}
